import React from 'react';
export function SolutionSection() {
  return <section className="bg-gradient-to-b from-dark-900 via-[#1a1500] to-dark-900 py-[80px] px-5 text-center" data-id="element-413" data-mp="324booh7b1n7j">
      <div className="max-w-[1100px] mx-auto" data-id="element-414" data-mp="3ablvrthenkpv">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-alphaGold" data-id="element-415" data-mp="3o9k86tc6172q">
          La Solución Ya Existe —<br data-id="element-416" data-mp="3j8w8zkds9jxf" />Y Está en AlphaFit
        </h2>

        <div className="max-w-[800px] mx-auto text-[1.1rem] leading-[1.9] text-[#ccc] mt-8" data-id="element-417" data-mp="142sbit7r70l">
          <p data-id="element-418" data-mp="3t8n3hm2cfyxi">
            No necesitás gastar fortunas en marcas importadas ni esperar semanas
            para que llegue tu pedido.
            <strong className="text-white" data-id="element-419" data-mp="at2t97ra0chf"> Cibeles y Profit</strong> son las
            marcas de suplementos de calidad certificada disponibles ahora
            mismo, en tu ciudad, a precios que tienen sentido.
          </p>
        </div>

        <div className="bg-alphaGold/10 border border-alphaGold/30 rounded-md p-[30px] my-[40px] mx-auto max-w-[700px] text-[1.2rem] font-bold text-white leading-[1.6]" data-id="element-420" data-mp="kq7g79sy4bza">
          "Con la suplementación correcta, tu cuerpo tiene todo lo que necesita
          para crecer, recuperarse y rendir al máximo — entrenamiento tras
          entrenamiento."
        </div>

        <div className="max-w-[800px] mx-auto text-[1.1rem] leading-[1.9] text-[#ccc]" data-id="element-421" data-mp="3f9qycgkvq5ab">
          <p data-id="element-422" data-mp="3kb6k6auvsftr">
            En <strong className="text-white" data-id="element-423" data-mp="3kboozvvm02da">AlphaFit</strong> creemos en la
            calidad sin excusas. Cada producto está formulado para resultados
            reales — no promesas vacías. Y hoy, con{' '}
            <strong className="text-white" data-id="element-424" data-mp="3u6gm6yla4n7j">20% OFF</strong>, no hay razón para
            esperar.
          </p>
        </div>
      </div>
    </section>;
}